import { render } from "./Users.vue?vue&type=template&id=1df97a94"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=1df97a94&lang=scss"
script.render = render

export default script